/* reveler.js — les sections apparaissent au défilement, les traits de feutre se tracent. */
(function () {
  'use strict';

  var cibles = document.querySelectorAll('section, .reveler, .heros');

  if (!('IntersectionObserver' in window)) {
    cibles.forEach(function (c) { c.classList.add('vu'); });
    return;
  }

  var oeil = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vu'); oeil.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  cibles.forEach(function (c) { oeil.observe(c); });

  var heros = document.querySelector('.heros');
  if (heros) { heros.classList.add('vu'); }
})();
